import React from 'react';
import { Button, } from 'antd-mobile'
import './index.scss';
function SuccessPage() {
    let search = window.location.search.slice(1)
    let params = search.split('&')
    var theRequest = new Object()
    for (let i = 0; i < params.length; i++) {
        theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
    }
    document.title = theRequest.organizationName
    const emptyIcon = require('../../assets/wancheng.png')
    const closePage = () => {
        setTimeout(() => {
            window.showToast()
        }, 1000)
    }
    return (
        <div className="success-page">
            <div className="success-page-content">
                <img className="emptyIcon" src={emptyIcon} />
                <div className="title">充值成功</div>
                {/* <Button block onClick={() => {closePage()
                }} color='primary' size='large'>
                    返回钱包
          </Button> */}
            </div>

        </div>
    );
}

export default SuccessPage;
